import { render } from "./ClientAdmin.vue?vue&type=template&id=792b0602"
import script from "./ClientAdmin.vue?vue&type=script&lang=js"
export * from "./ClientAdmin.vue?vue&type=script&lang=js"

import "./ClientAdmin.vue?vue&type=style&index=0&id=792b0602&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__